<template>
  <div class="ear-lobe-container">
    <div class="content-section">
      <h2 class="pb-2 border-bottom">
        Reparación del Lóbulo de la Oreja & Otomodelación No Quirúrgica
      </h2>
      <p>
        En Diverse Care Now, ofrecemos procedimientos simples y seguros para
        restaurar el equilibrio, corregir asimetrías y reparar lóbulos de las
        orejas — sin necesidad de cirugía tradicional. Nuestro objetivo es
        brindar resultados naturales con mínimo tiempo de recuperación.
      </p>
      <h3>¿Quién puede beneficiarse de la otomodelación?</h3>
      <ul>
        <li>
          Pacientes con lóbulos rasgados o alargados (a menudo por aretes).
        </li>
        <li>Personas con orejas prominentes o asimétricas.</li>
        <li>Irregularidades leves que no requieren cirugía.</li>
        <li>Quienes buscan correcciones sutiles, sin cicatrices visibles.</li>
      </ul>
      <h3>Técnicas utilizadas</h3>
      <ul>
        <li>
          Relleno dérmico — restaura forma y volumen para un contorno más
          equilibrado.
        </li>
        <li>
          Hilos PDO / PLLA — lifting mínimamente invasivo para corregir ángulos
          y mejorar la simetría.
        </li>
        <li>
          PRP o relleno para rejuvenecimiento — devuelve elasticidad y previene
          nuevas lesiones.
        </li>
        <li>
          Extirpación de quistes — procedimiento rápido y seguro con anestesia
          local.
        </li>
      </ul>
      <h3>Resumen del procedimiento</h3>
      <ul>
        <li>Anestesia local para mayor comodidad.</li>
        <li>Aplicación de rellenos, hilos o PRP según necesidad.</li>
        <li>Resultados inmediatos, con mínima inflamación (24–48h).</li>
      </ul>
      <p>
        "Desde el cuidado estético hasta la eliminación de quistes, nuestros
        procedimientos mínimamente invasivos devuelven comodidad, equilibrio y
        confianza."
      </p>
    </div>
    <div class="otomodeling-video">
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        "
        src="https://www.youtube.com/embed/9rbA47bOvms"
        title="YouTube Shorts: Ear Lobe Repair"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "EarLobeRepairContentEs",
};
</script>

<style scoped>
.ear-lobe-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.content-section {
  flex: 1;
  min-width: 0;
}

.otomodeling-video {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
}

.otomodeling-video iframe {
  width: 320px;
  height: 568px;
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* Responsive design */
@media (max-width: 768px) {
  .ear-lobe-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .otomodeling-video {
    align-self: center;
  }

  .otomodeling-video iframe {
    width: 280px;
    height: 497px;
  }
}

@media (max-width: 480px) {
  .otomodeling-video iframe {
    width: 240px;
    height: 426px;
  }
}
</style>
